import { NavLink } from 'react-router-dom'
import { House, CoatHanger, MagicWand, Airplane, UserCircle } from '@phosphor-icons/react'
import { cn } from '@/lib/utils'

export function MobileNav() {
  const navItems = [
    { to: '/', label: 'Home', icon: House },
    { to: '/closet', label: 'Closet', icon: CoatHanger },
    { to: '/stylist', label: 'Stylist', icon: MagicWand },
    { to: '/trip', label: 'Trip', icon: Airplane },
    { to: '/profile', label: 'Profile', icon: UserCircle },
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe-bottom z-40 md:hidden">
      <div className="grid grid-cols-5 h-16 px-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-1 transition-all duration-300 relative',
                isActive
                  ? 'text-gray-900'
                  : 'text-gray-400 hover:text-gray-600 active:scale-95'
              )
            }
          >
            {({ isActive }) => (
              <>
                {/* Icon with background pill for active state */}
                <div className={cn(
                  "flex items-center justify-center transition-all duration-300 rounded-full",
                  isActive ? "bg-black w-12 h-7" : "w-7 h-7"
                )}>
                  <item.icon
                    size={isActive ? 20 : 24}
                    weight={isActive ? "fill" : "regular"}
                    className={cn(
                      "transition-all duration-300",
                      isActive ? "text-white" : ""
                    )}
                  />
                </div>
                {/* Label - hidden when active to save space */}
                <span className={cn(
                  "text-[10px] transition-all duration-300 leading-tight",
                  isActive ? "font-bold opacity-0 h-0" : "font-medium opacity-100"
                )}>
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
